import { Text, Flex, Image, VStack, AspectRatio, Heading, Box, Stack } from '@chakra-ui/react'
import React from 'react'
import Carousel from './Carousel'

const Design = ( { text } ) => {

  const images = [
    'data/assets/JusticeLeague/justice-league-1.jpg',
    'data/assets/JusticeLeague/justice-league-2.jpg',
    'data/assets/JusticeLeague/justice-league-3.jpg',
    'data/assets/JusticeLeague/justice-league-4.jpg',
    'data/assets/JusticeLeague/justice-league-5.jpg',
    'data/assets/JusticeLeague/justice-league-6.jpg',  
  ]
  
  return (
    <Box>
      {/* PRIMERA FILA */}
      <Flex minH={['auto','auto','auto','115vh','100vh']} direction={['column','column','column','row']}>
        <VStack w='full' minH='full' bg='black' justifyContent='center' pt={['25%','25%','10%','0%','0%']}>
            <Image 
              src='img/aitenea.png' 
              boxSize={['90%','80%']}
              objectFit='contain'
            />
        </VStack>
        {/* segundo vstack */}
        <VStack  w='full' minH='full' bg={['black','black','black','white']} justifyContent='center' pt={['10%','10%','0%','0%','0%']} pb={['20%','20%','0%','0%','0%']}> 
          <VStack alignItems='center'  w={['100%','524px']}  textAlign='center' px={['4%','4%','0%','0%','0%']} py={['0%','0%','10%','2%','2%']}>
            <Heading fontWeight={'900'} pb={['10%','4%']} color={['white','white','white','black']}>Aitenea Biotech (2020)</Heading>
            <Text color={['white','white','white','black']} pb={['2%','2%']}>{text.aitenea_1}</Text>
            
            <Text pb='5%' color={['white','white','white','black']}>{text.aitenea_2}</Text>
            <AspectRatio w={['80%','85%']} ratio={16/9} >
              <iframe
                  title='Pedro Serrano'
                  src='https://www.youtube.com/embed/Lv7IgYMBJLE'
                  allowFullScreen
              />
            </AspectRatio>     
          </VStack>
        </VStack>
      </Flex>
      
      {/* SEGUNDA FILA */}
      <Flex minH={['auto','auto','auto','120vh','100vh']} direction={['column','column','column','row']}>
        <VStack w='full' minH='full' bg='white' py={['0%','0%','0%','2%','2%']}>
          <VStack alignItems='center' textAlign='center' px={['4%','4%','0%','0%','0%']}>
            <Heading fontWeight={'900'} pt={28}>Justice League: Dawn of heroes </Heading>
            <Text w={['100%','544px']} pt={8} pb={['10%',20]} px={['2%','0%']}>{text.justice}</Text>
            <AspectRatio w={['80%','80%','100%','600px','555px']} ratio={16/9}>
              <iframe
                title='Justice League'
                src='https://www.youtube.com/embed/xfnQdMII0fo'
                allowFullScreen
                />
            </AspectRatio>
          </VStack>
        </VStack>
        <VStack  
          w='full' 
          minH='full' 
          bg={['white','white','white','black']} 
          justifyContent='center'
        > 
          <Stack py={['15%','15%','5%','0%','0%']}>              
            <Carousel images={images} size={600} dots={true} />
          </Stack>
        </VStack>
      </Flex>    
      {/* TERCERA FILA */}
      <Flex minH={['auto','auto','auto','130vh','100vh']} direction={['column','column','column','row']} pt={['10%','10%','0%','0%','0%']} >
        <VStack w='full' minH='full' bg={['black','black']} justifyContent='center' py={['0%','0%','10%','0%','0%']}>
            <Image 
              src='img/adventure-time.jpg' 
              boxSize={['90%','80%']}
              objectFit='contain'
              pt={['10%','0%']}
            />
        </VStack>
        <VStack  w='full' minH='full' bg='white' justifyContent='center' bgColor={['black','white']} pb={['20%','20%','10%','0%']}>  
          <VStack alignItems='center'  w={['100%','574px']}  textAlign='center' pt={['5%','5%','10%','2%','2%']} pb={['0%','0%','0%','2%','2%']} px={['4%','4%','0%','0%','0%']}>
            <Heading fontWeight={'900'} color={['white','black']}> { text.adventureTime.tit } </Heading>
            <Heading fontWeight={'900'} color={['white','black']} pb={8}>{ text.adventureTime.subtit }</Heading>
            <Text color={['white','black']}> { text.adventureTime.sub_1 } </Text>
            <br/>
            <Text pb='20' color={['white','black']}>{ text.adventureTime.sub_2 }</Text>
            <AspectRatio  w={['80%','555px']} ratio={16/9}>
              <iframe
                  title='Adventure Time'
                  src='https://www.youtube.com/embed/glECGKPyBfQ'
                  allowFullScreen
              />
            </AspectRatio>     
          </VStack>
        </VStack>
      </Flex>    
    </Box>
  )
}

export default Design;